/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import log, { utilNormalizeCase } from "../../utility/logging";
import { Button, Flex, Form, Input, message, Modal, Popover, Select, Slider, Table, TableProps, Tabs, Tag, Tooltip } from "antd";
import { TutorTabRecommendationResponseType, TutorTabRenderProps } from "./types";
import { PublicTutorTab } from "./PublicTutorTab";
import axios from "../../axios";
import {
  CloseCircleOutlined,
  CompassOutlined,
  HeartFilled,
  HeartOutlined,
  InfoCircleFilled,
  SendOutlined,
} from "@ant-design/icons/lib/icons";
import { omit, debounce, some } from "lodash";
import { renderBoolean } from "../table-utils";
import "./tutor-status-rows.css";

const getStatusBgColor = (status?: string) => {
  const s = (status || "").toLowerCase();
  if (s === "blocked" || s === "block") return "#FF6F71";
  if (s === "inactive") return "#D9D9D9";
  if (s === "warning") return "#F2C051";
  return undefined;
};
// import { adminEditDealState } from "../../states/userRole";
// import { useAtom } from "jotai";

const { Option } = Select;

export function TutorTabRender(props: TutorTabRenderProps) {
  const { studentDetails } = props;
  const [inputValue, setInputValue] = useState(1);

  // const navigate = useNavigate();
  // const location = useLocation();

  const [form] = Form.useForm();
  // TODO: Handle pagination
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [masterDataFetched, setMasterDataFetched] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState<Record<string, string | undefined>>({});
  const [subjectMaster, setSubjectMaster] = useState<string[]>([]);
  const [streamMaster, setStreamMaster] = useState<Record<string, string>>({});
  const [tutorsListing, setTutorsListing] = useState<TutorTabRecommendationResponseType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [metaInfo, setMetaInfo] = useState({ total: 0 });
  // const [canAdminEditDeal, _setCanAdminEditDeal] = useAtom(adminEditDealState);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<TutorTabRecommendationResponseType[]>([]);

  const [messageApi, contextHolder] = message.useMessage();

  const TutorRecommendationTableColumns = [
    {
      title: "Tutor Name",
      dataIndex: "tutor_name",
      key: "tutor_name",
      align: "center",
      className: "tutor-name-cell",
      width: 180,
      render: (_: any, record: Record<string, string>) => {
        return (
          <Tooltip placement="topLeft" title={record.tutor_name}>
            <div
              style={{
                padding: "5px",
              }}
            >
              {record.tutor_name}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Phone No.",
      dataIndex: "phone",
      key: "phone",
      align: "center",
      width: 150,
    },
    {
      title: "Verified",
      dataIndex: "is_verified",
      key: "is_verified",
      align: "center",
      render: renderBoolean,
      width: 100,
      onCell: (record: TutorTabRecommendationResponseType) => ({
        style: {
          color: record.is_verified ? "#ffffff" : undefined,
          backgroundColor: record.is_verified ? "#1bb83d" : undefined,
        },
      }),
    },
    {
      title: "Applied",
      dataIndex: "is_applied",
      key: "is_applied",
      align: "center",
      render: renderBoolean,
      width: 100,
      onCell: (record: TutorTabRecommendationResponseType) => ({
        style: {
          color: record.is_applied ? "#ffffff" : undefined,
          backgroundColor: record.is_applied ? "#1bb83d" : undefined,
        },
      }),
    },
    {
      title: "Whatsapp Interest",
      dataIndex: "is_whatsapp_applied",
      key: "is_whatsapp_applied",
      align: "center",
      render: renderBoolean,
      width: 100,
      onCell: (record: TutorTabRecommendationResponseType) => ({
        style: {
          color: record.is_whatsapp_applied ? "#ffffff" : undefined,
          backgroundColor: record.is_whatsapp_applied ? "#1bb83d" : undefined,
        },
      }),
    },
    {
      title: "Whatsapp Counter",
      dataIndex: "hotlead_count",
      key: "hotlead_count",
      align: "center",
      width: 80,
      render: (cellValue: number) => <span>{cellValue || 0}</span>,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      align: "center",
      width: 100,
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      align: "center",
      render: (cellValue: string) => <span>{cellValue} km</span>,
      width: 100,
    },
    {
      title: "Google Distance",
      dataIndex: "location",
      key: "location",
      align: "center",
      render: function (cellValue: string) {
        return (
          <Button
            size="small"
            type="link"
            className="tail-mx-auto"
            icon={<CompassOutlined></CompassOutlined>}
            iconPosition="end"
            href={cellValue}
            target="_blank"
          >
            View Distance
          </Button>
        );
      },
      width: 200,
    },
    {
      title: "Expertise",
      dataIndex: "expertise",
      key: "expertise",
      ellipsis: true,
      width: 250,
      render: (_: any, record: Record<string, string>) => {
        return (
          <Tooltip placement="topLeft" title={record.expertise}>
            <div
              style={{
                padding: "5px",
              }}
            >
              {record.expertise}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Syllabus",
      dataIndex: "tutor_stream_id",
      key: "tutor_stream_id",
      width: 250,
      ellipsis: true,
      // render: (cellValue: Array<number | string>) => {
      //   return (
      //     <span>
      //       {cellValue
      //         .map((streamId) => streamMaster[streamId as number])
      //         .join(", ")}
      //     </span>
      //   );
      // },
      render: (cellValue: Array<number | string>) => {
        const syllabus = cellValue.map((streamId) => streamMaster[streamId as number]).join(", ");
        return (
          <Tooltip placement="topLeft" title={syllabus}>
            <div
              style={{
                padding: "5px",
              }}
            >
              {syllabus}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Match Percentage",
      dataIndex: "match_percentage",
      key: "match_percentage",
      align: "center",
      width: 150,
      render: (cellValue: string) => <span>{cellValue} %</span>,
    },
    {
      title: "Rating",
      dataIndex: "tutor_rating",
      key: "tutor_rating",
      align: "center",
      width: 80,
      render: (cellValue: number) =>
        cellValue > 0 ? (
          <span style={{ color: "#faad14" }}>
            {"★".repeat(Math.round(cellValue))}
            <span style={{ color: "#d9d9d9" }}>
              {"★".repeat(5 - Math.round(cellValue))}
            </span>
          </span>
        ) : (
          <span style={{ color: "#d9d9d9" }}>★★★★★</span>
        ),
    },
    {
      title: "Shortlisted",
      dataIndex: "is_shortlisted",
      key: "is_shortlisted",
      align: "center",
      fixed: true,
      render: (cellValue: boolean, rowRecordObject: TutorTabRecommendationResponseType) => {
        const status = (rowRecordObject.tutor_status || "").toLowerCase();
        const isSpecialRow = ["blocked", "inactive", "warning"].includes(status);
        return (
          <Flex align="center" justify="center">
            <Button
              // disabled={!canAdminEditDeal}
              className="mx-auto"
              type="link"
              shape="circle"
              iconPosition="end"
              style={isSpecialRow ? { color: "#9A9A9A" } : undefined}
              icon={
                cellValue ? (
                  <HeartFilled style={isSpecialRow ? { color: "#9A9A9A" } : undefined} />
                ) : (
                  <HeartOutlined style={isSpecialRow ? { color: "#9A9A9A" } : undefined} />
                )
              }
              onClick={() => {
                setShortlistedStatus(rowRecordObject.tutor_id, rowRecordObject.id);
              }}
            ></Button>
          </Flex>
        );
      },
      width: 100,
    },
    {
      title: "Hot Lead",
      dataIndex: "is_hotlead",
      key: "is_hotlead",
      align: "center",
      // render: renderBoolean,
      width: 100,
      render: (_cellValue: boolean, rowRecordObject: TutorTabRecommendationResponseType) => {
        const status = (rowRecordObject.tutor_status || "").toLowerCase();
        const isSpecialRow = ["blocked", "inactive", "warning"].includes(status);
        return (
          <Button
            // disabled={!canAdminEditDeal}
            color={isSpecialRow ? undefined : "danger"}
            variant={rowRecordObject.is_hotlead ? "filled" : "outlined"}
            className="mx-auto"
            style={
              isSpecialRow
                ? {
                  color: "#9A9A9A",
                  borderColor: "#9A9A9A",
                  border: "1px solid #9A9A9A",
                }
                : undefined
            }
            onClick={() => {
              confirmSendWhatsApp({
                content: "Do you want to send WhatsApp recommendation message?",
                onYes: () => markTutorRecommendationAsHotlead(rowRecordObject.tutor_id, rowRecordObject.id, true),
                onNo: () => markTutorRecommendationAsHotlead(rowRecordObject.tutor_id, rowRecordObject.id, false),
              });
            }}
          >
            <span style={isSpecialRow ? { color: "#9A9A9A" } : undefined}>
              Hot Lead <SendOutlined style={isSpecialRow ? { color: "#9A9A9A" } : undefined} />
            </span>
          </Button>
        );
      },
    },

    {
      title: "Tutor Details",
      dataIndex: "tutor_id",
      key: "tutor_id",
      align: "center",
      width: 200,
      render: (cellValue: string) => (
        <Button
          className="tail-mx-auto"
          type="text"
          iconPosition="end"
          icon={<InfoCircleFilled className="tail-text-blue-500" />}
          href={`/tutor/${cellValue}`}
          target="_blank"
        >
          Details
        </Button>
      ),
    },
  ];

  const shouldDisplayFilter = (value: null | undefined | string) => {
    return value !== null && value !== undefined && value !== "";
  };

  useEffect(() => {
    created();
  }, []);

  useEffect(() => {
    if (masterDataFetched) {
      fetchTutorRecoList();
    }
  }, [appliedFilters, page, masterDataFetched]);

  async function created() {
    if (!masterDataFetched) {
      await fetchSubjectMaster();
      await fetchStreamMaster();
    }
    setMasterDataFetched(true);
  }

  async function fetchSubjectMaster() {
    try {
      const response = await axios.get(`v1/cre/master/course/all`);
      setSubjectMaster(response.data);
    } catch (error) {
      log.debug(`Error fetching v1/cre/master/course/all`, error);
    }
  }

  async function fetchStreamMaster() {
    try {
      const response = await axios.get(`v1/cre/streams`);
      setStreamMaster(response.data?.data);
    } catch (error) {
      log.debug(`Error fetching v1/cre/streams`, error);
    }
  }

  async function fetchTutorRecoList() {
    setLoading(true);
    try {
      console.log("appliedFilters", appliedFilters);
      const { match_percentage_filter, ...apiFilters } = appliedFilters;
      const { data } = await axios.get(`v1/cre/student/recommendation`, {
        params: {
          dealings_id: studentDetails.id,
          page: page,
          limit: 25,
          ...apiFilters,
        },
      });
      console.log(data);
      if (data?.data?.data) {
        setTutorsListing(data.data.data);
        setMetaInfo({ total: data.data.meta.total });
      }
    } catch (error) {
      console.error(`Error fetching v1/cre/student/recommendation for record ${studentDetails.id}:`, error);
    } finally {
      setLoading(false);
    }
  }

  async function setShortlistedStatus(tutorId: string | number, recommendationId: string | number) {
    try {
      const response = await axios.post(`v1/cre/student/shortlist-tutor`, {
        tutor_id: tutorId,
        dealings_id: studentDetails.id,
        recommendation_id: recommendationId,
      });
      // TODO optimize this at local level
      if (response.data.success) {
        fetchTutorRecoList();
      }
    } catch (error) {
      log.debug(`Error fetching v1/cre/student/shortlist-tutor`, error);
    }
  }

  async function markTutorRecommendationAsHotlead(
    tutorId: string | number,
    recommendationId: string | number,
    isSendRecommendation: boolean,
  ) {
    try {
      setLoading(true);
      const response = await axios.post(`v1/cre/student/recommendation/hotlead`, {
        tutor_id: tutorId,
        dealings_id: studentDetails.id,
        recommendation_id: recommendationId,
        isSendRecommendation,
      });
      if (response.data?.success) {
        messageApi.info(isSendRecommendation ? "Hot lead marked and WhatsApp sent" : "Hot lead marked");
        fetchTutorRecoList();
      }
    } catch (error) {
      log.debug(`Error fetching v1/cre/student/recommendation/hotlead`, error);
    } finally {
      setLoading(false);
    }
  }

  function confirmSendWhatsApp({
    content,
    onYes,
    onNo,
  }: {
    content: string;
    onYes: () => void | Promise<void>;
    onNo: () => void | Promise<void>;
  }) {
    Modal.confirm({
      title: "Send WhatsApp Message",
      content,
      okText: "No",
      cancelText: "Yes, Send",
      okButtonProps: { type: "primary" },
      cancelButtonProps: { type: "default" },
      onOk: onNo,
      onCancel: onYes,
    });
  }

  // Bulk operations for selected rows
  async function handleBulkShortlist() {
    if (selectedRows.length === 0) {
      messageApi.warning("Please select at least one tutor to shortlist");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        recommendations: selectedRows.map((row) => ({
          tutor_id: row.tutor_id,
          dealings_id: studentDetails.id,
          recommendation_id: row.id,
        })),
      };

      const response = await axios.post(`v1/cre/student/bulk-shortlist-tutors`, payload);

      if (response.data?.success) {
        messageApi.success(`${selectedRows.length} tutors shortlisted successfully`);
        setSelectedRowKeys([]);
        setSelectedRows([]);
        fetchTutorRecoList();
      } else {
        messageApi.error("Failed to shortlist tutors");
      }
    } catch (error) {
      messageApi.error("Error shortlisting tutors");
      log.debug(`Error in bulk shortlist`, error);
    } finally {
      setLoading(false);
    }
  }

  function handleBulkHotLeads() {
    if (selectedRows.length === 0) {
      messageApi.warning("Please select at least one tutor to mark as hot lead");
      return;
    }

    confirmSendWhatsApp({
      content: `Do you want to send WhatsApp recommendation message to ${selectedRows.length} selected tutor(s)?`,
      onNo: () => submitBulkHotLeads(false),
      onYes: () => submitBulkHotLeads(true),
    });
  }

  async function submitBulkHotLeads(isSendRecommendation: boolean) {
    try {
      setLoading(true);
      const payload = {
        recommendations: selectedRows.map((row) => ({
          dealings_id: studentDetails.id,
          tutor_id: row.tutor_id,
          recommendation_id: row.id,
        })),
        isSendRecommendation,
      };

      const response = await axios.post(`v1/cre/student/recommendation/bulk-hotlead`, payload);
      if (response.data?.success) {
        messageApi.success(
          isSendRecommendation
            ? `${selectedRows.length} tutors marked as hot leads and WhatsApp sent`
            : `${selectedRows.length} tutors marked as hot leads successfully`,
        );
        setSelectedRowKeys([]);
        setSelectedRows([]);
        fetchTutorRecoList();
      } else {
        messageApi.error("Failed to mark tutors as hot leads");
      }
    } catch (error) {
      messageApi.error("Error marking tutors as hot leads");
      log.debug(`Error in bulk hot leads`, error);
    } finally {
      setLoading(false);
    }
  }

  function handleTagClose(filterKey: string): void {
    if (filterKey === "match_percentage_filter") {
      setAppliedFilters(omit(appliedFilters, ["match_percentage_filter", "match_percentage_min", "match_percentage_max"]));
      form.setFieldValue("match_percentage_filter", undefined);
    } else {
      setAppliedFilters(omit(appliedFilters, [filterKey]));
      form.setFieldValue(filterKey, undefined);
    }
  }

  function handleClearAll(): void {
    form.resetFields();
    setAppliedFilters({});
  }

  // Row selection handlers
  const rowSelection = {
    type: "checkbox" as const,
    columnWidth: 50,
    selectedRowKeys,
    onChange: (newSelectedRowKeys: React.Key[], newSelectedRows: TutorTabRecommendationResponseType[]) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(newSelectedRows);
    },
  };

  function handleFilterChange(
    changedValues: Record<string, string | undefined>,
    allValues: Record<string, string | undefined>,
  ): void {
    // Skip if only match_percentage_filter changed (handled by its own onChange)
    if (Object.keys(changedValues).length === 1 && "match_percentage_filter" in changedValues) {
      return;
    }
    const { match_percentage_filter, ...formValues } = allValues;
    setAppliedFilters((prev) => {
      // Preserve match percentage keys that are managed separately
      const preserved: Record<string, string | undefined> = {};
      if (prev.match_percentage_min) preserved.match_percentage_min = prev.match_percentage_min;
      if (prev.match_percentage_max) preserved.match_percentage_max = prev.match_percentage_max;
      if (prev.match_percentage_filter) preserved.match_percentage_filter = prev.match_percentage_filter;
      return { ...formValues, ...preserved };
    });
  }
  const debouncedHandleChange = useCallback(
    debounce((changedValues, allValues) => {
      handleFilterChange(changedValues, allValues);
    }, 300), // Adjust debounce delay as needed
    [],
  );



  const recommendationContent = (
    <>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changedValues, allValues) => debouncedHandleChange(changedValues, allValues)}
        initialValues={{}}
      >
        <Flex
          wrap={true}
          className="[&>div]:tail-w-full [&>div]:tail-grow [&>div]:[&>div]:tail-grow tail-grow tail-gap-x-4"
        >
          <Form.Item layout="horizontal" name="tutor_name" className="tail-flex tail-gap-x-2">
            <Input placeholder="Search tutors..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            {/* <Button type="primary" onClick={() => updateSearchTermFilter(searchTerm)}>
            Search
          </Button> */}
          </Form.Item>
        </Flex>
        <Flex wrap={true} className="[&>div]:tail-w-40 tail-gap-x-4">
          <Form.Item label="Verified" name="tutor_verified_status">
            <Select placeholder="Select" allowClear>
              <Option value="Verified">Verified</Option>
              <Option value="Not_Verified">Not Verified</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Applied" name="tutor_applied_status">
            <Select placeholder="Select" allowClear>
              <Option value="Applied">Applied</Option>
              <Option value="Not_Applied">Not Applied</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Gender" name="gender">
            <Select placeholder="Select" allowClear>
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Profile Status" name="profile_status">
            <Select placeholder="Select status" allowClear>
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
              <Option value="Blocked">Blocked</Option>
              <Option value="Warning">Warning</Option>
            </Select>
          </Form.Item>
          {/* TODO improve this into a standalone component */}
          <Form.Item label="Distance" name="distance">
            <Popover
              content={
                <div className="tail-min-w-52">
                  <div>
                    <span>Within {inputValue} km</span>
                  </div>
                  <div className="tail-mt-2 tail-flex">
                    <Form.Item label="Distance Range" name="distance" className="tail-w-full tail-mb-0">
                      <Slider
                        min={1}
                        max={20}
                        onChange={(value) => setInputValue(value)}
                        value={typeof inputValue === "number" ? inputValue : 0}
                        className="tail-grow"
                      ></Slider>
                    </Form.Item>
                  </div>
                </div>
              }
              trigger="click"
            >
              <Button className="tail-w-full tail-text-neutral-300 !tail-justify-start">Select distance</Button>
            </Popover>
          </Form.Item>

          <Form.Item label="Subjects" name="subject">
            <Select placeholder="Select subject" mode="multiple">
              {subjectMaster.map((subject) => (
                <Option key={subject} value={subject}>
                  {subject}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {/* // TODO: api to fetch syllabus */}
          <Form.Item label="Syllabus" name="syllabus">
            <Select placeholder="Select syllabus" allowClear>
              {Object.entries(streamMaster)?.map(([id, name]) => {
                return (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item label="Match %" name="match_percentage_filter">
            <Select
              placeholder="Select"
              allowClear
              onChange={(value) => {
                if (value) {
                  const [min, max] = value.split("-");
                  setAppliedFilters((prev) => ({
                    ...prev,
                    match_percentage_min: min,
                    match_percentage_max: max,
                    match_percentage_filter: value,
                  }));
                } else {
                  setAppliedFilters((prev) => {
                    const { match_percentage_min, match_percentage_max, match_percentage_filter, ...rest } = prev;
                    return rest;
                  });
                }
              }}
            >
              <Option value="70-80">70% - 80%</Option>
              <Option value="80-90">80% - 90%</Option>
              <Option value="90-100">90% - 100%</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Tutor Created" name="tutor_created_months">
            <Select placeholder="Select" allowClear>
              <Option value="3">Last 3 Months</Option>
              <Option value="6">Last 6 Months</Option>
              <Option value="9">Last 9 Months</Option>
              <Option value="12">Last 12 Months</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Subscription Date" name="subscription_date_months">
            <Select placeholder="Select" allowClear>
              <Option value="3">Last 3 Months</Option>
              <Option value="6">Last 6 Months</Option>
              <Option value="9">Last 9 Months</Option>
              <Option value="12">Last 12 Months</Option>
            </Select>
          </Form.Item>
        </Flex>
      </Form>

      {/* Filters */}
      {some(appliedFilters) && (
        <div className="">
          <div className="tail-flex tail-mb-4 tail-gap-2">
            <h4>Applied Filters</h4>|
            <Button type="text" size="small" className="tail-underline" onClick={() => handleClearAll()}>
              Clear All
            </Button>
          </div>
          <div className="tail-flex tail-flex-wrap tail-gap-2">
            {Object.entries(appliedFilters).map(
              ([filterKey, value]) =>
                shouldDisplayFilter(value as string | null) &&
                filterKey !== "match_percentage_min" &&
                filterKey !== "match_percentage_max" && (
                  <Tag
                    key={[filterKey, value].join(":")}
                    closable
                    closeIcon={<CloseCircleOutlined />}
                    color="processing"
                    onClose={() => handleTagClose(filterKey)}
                  >
                    {filterKey === "match_percentage_filter"
                      ? `Match %: ${value?.toString().replace("-", "% - ")}%`
                      : `${utilNormalizeCase(filterKey)}: ${value as string | null}`}
                  </Tag>
                ),
            )}
          </div>
        </div>
      )}

      <div className="tail-mt-4 tail-flex tail-justify-end tail-items-start">
        <div className="tail-flex  tail-gap-2">
          <Button className="tail-text-neutral-400" onClick={handleBulkShortlist} disabled={selectedRows.length === 0}>
            Shortlist ({selectedRows.length})
          </Button>
          <Button className="tail-text-neutral-400" onClick={handleBulkHotLeads} disabled={selectedRows.length === 0}>
            Hot Leads ({selectedRows.length})
          </Button>
        </div>
      </div>
      <div className="p-0">
        <Table
          loading={loading}
          dataSource={tutorsListing as TableProps<TutorTabRecommendationResponseType>["dataSource"]}
          scroll={{ x: "100%" }}
          pagination={{
            total: metaInfo.total,
            pageSize: 25,
            onChange: (page, pageSize) => setPage(page),
            showSizeChanger: false,
            current: page,
          }}
          bordered={true}
          onChange={(pagination, filters, sorter, extra) => {
            console.log("pagination", pagination, "filters", filters, "sorter", sorter, "extra", extra);
          }}
          tableLayout="fixed"
          rowKey="id"
          rowSelection={rowSelection}
          rowClassName={(record) => {
            const status = (record.tutor_status || "").toLowerCase();
            if (status === "blocked" || status === "block") return "tutor-row-blocked";
            if (status === "inactive") return "tutor-row-inactive";
            if (status === "warning") return "tutor-row-warning";
            return "";
          }}
          columns={TutorRecommendationTableColumns as TableProps<TutorTabRecommendationResponseType>["columns"]}
        ></Table>
      </div>
    </>
  );

  return (
    <div className="tutors-container tail-p-4">
      {contextHolder}
      <Tabs
        defaultActiveKey="recommendations"
        items={[
          {
            key: "recommendations",
            label: `Recommendations${selectedRows.length > 0 ? ` (${selectedRows.length} selected)` : ""}`,
            children: recommendationContent,
          },
          {
            key: "public-tutor",
            label: "Public Tutor",
            children: <PublicTutorTab dealingsId={studentDetails.id} />,
          },
        ]}
      />
    </div>
  );
}

export default TutorTabRender;
